function stripTimezoneFromHour(hour: string): string {
  return hour.split(/[+-]/)[0].trim();
}

export function isVisibleByHour(
  initialHour: string | null | undefined,
  finalHour: string | null | undefined
): boolean {
  if (initialHour && finalHour) {
    const nowDate = new Date();
    const initialDate = new Date(
      `${nowDate.toISOString().split("T")[0]} ${stripTimezoneFromHour(initialHour)}`
    );
    const finalDate = new Date(
      `${nowDate.toISOString().split("T")[0]} ${stripTimezoneFromHour(finalHour)}`
    );
    if (
      initialDate.getTime() <= nowDate.getTime() &&
      finalDate.getTime() >= nowDate.getTime()
    ) {
      return true;
    }

    return false;
  }

  return true;
}
